import React from "react";
import LeftRightComboWithList from "../common/LeftRightComboWithList";

const DataWarehousing = ({ title, data = [] }) => {
    return (
        <div className="mt-[30px] md:mt-[50px] sm:mt-28 flex justify-center">
            <div className="xl:max-w-[1000px] 3xl:max-w-[1200px]">
                <div className="md:container md:mx-auto mt-[20px] ">
                    <div id={title} className="text-[#141619]  text-[22px] sm:text-[32px] md:text-[35px] 3xl:text-[54px] font-[700] flex flex-col justify-center items-center">
                        <span className="sora md:leading-[63px] mb-[-20px]">
                            {title}
                        </span>
                    </div>
                </div>
                {data &&
                    data.map((item, index) => {
                        return (
                            <LeftRightComboWithList
                                key={index}
                                mainTitle={item.mainTitle}
                                subTitle={item.subTitle}
                                list={item.list}
                                image={item.image}
                                buttonText={item.buttonText}
                                section={item.section}
                                index={index}
                            />
                        );
                    })}
            </div>

        </div>
    );
};

export default DataWarehousing;
